import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-settings-component',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  @Output()
  machinesAddedOrUpdated = new EventEmitter<boolean>();

  onMachinesAddedOrUpdated(): void {
    this.machinesAddedOrUpdated.emit();
  }
}
